import RestaurantWebsiteLink from "./RestaurantWebsiteLink";

export default RestaurantWebsiteLink;
